import React from 'react'

import ComplaintsDashboard from '../../components/complaintsDashboard/ComplaintsDashboard';
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs';


function ComplaintsDashboardPages() {
    return (
        <div>
               <Breadcrumbs breadCrumbsTitle={{
    id: "1",
    title_1: "Help & Support",
    title_2: "Complainant Dashboard",
  }} />
            <ComplaintsDashboard />
        </div>
    )
}

export default ComplaintsDashboardPages
